import { render, staticRenderFns } from "./expressConfig.vue?vue&type=template&id=4a2d646a&scoped=true"
import script from "./expressConfig.vue?vue&type=script&lang=js"
export * from "./expressConfig.vue?vue&type=script&lang=js"
import style0 from "./expressConfig.vue?vue&type=style&index=0&id=4a2d646a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d646a",
  null
  
)

export default component.exports